<template>
  <div>
    <a-spin :spinning="loading">
      <p class="text-dark font-weight-bold mb-2">School Modules Settings</p>
      <hr />
      <!-- <a-checkbox-group
        v-model="value"
        :options="modules"
        @change="getValue($event)"
      /> -->
      <div class="row" style="padding-left:20px,padding-right:20px">
        <div class="column" v-for="(data, index) in modules" :key="index">
        <b style="margin-right:5px">{{ data.label }}</b>
        <input class="mb-2"
          type="checkbox"
          :id="data.value"
          :value="data.value"
          :checked="checked"
          v-model="value"
          @change="getValue($event, index)"
        />
        </div>
      </div>
      <hr />
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleSave"
        >Save</a-button
      >
      <hr />
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'SchoolModules',
  mounted: function() {
    this.getModules()
  },
  computed: {
    schoolId: function() {
      return this.$route.params.id
    },
  },
  watch: {
    value: function(value) {
      return value
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      modules: [],
      value: [],
      checked: false,
    }
  },
  methods: {
    getValue(e, index) {
      if (e.target.checked === true) {
        // if 2
        var x = this.value.find(e => e === 10)
        var y = this.value.find(e => e === 2)
        if (x === undefined) {
          this.value.push(parseInt(y))
        }
        if (y === undefined) {
          this.value.push(parseInt(x))
        }
        if (y) {
          if (parseInt(index) === 1) {
            const currentValue = this.value.indexOf(10)
            if (index > -1) {
              this.value.splice(currentValue, 1)
            }
          }
        }
        if (x) {
          if (parseInt(index) === 9) {
            const currentValue = this.value.indexOf(2)
            if (index > -1) {
              this.value.splice(currentValue, 1)
            }
          }
        }
      }
    },
    getModules() {
      this.loading = true
      this.$http
        .get(`/api/modules/school/${this.schoolId}`)
        .then(({ data }) => {
          this.modules = data.data.map(element => {
            return {
              label: element.name,
              value: element.id,
            }
          })
          this.value = data.data
            .map(element => {
              if (element.selected) {
                return element.id
              }
            })
            .filter(element => element !== undefined)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleSave(e) {
      this.loading = true
      const cleanModules = this.value.filter(val => val !== null && val !== undefined && !isNaN(val))
      this.$confirm({
        title: `Are you sure?`,
        content: `Click on the OK button to update modules setting!`,
        onOk: () => {
          this.$http
            .post(`/api/modules/school/${this.schoolId}`, {
              modules: cleanModules, // Use the cleaned array here
            })
            .then(({ data }) => {
              this.$emit('saved')
              this.loading = false
              this.$notification['success']({
                message: 'Settings updated!',
                description: 'Module settings has been updated successfully.',
              })

              this.getModules()
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
  },
}
</script>
<style>
#navlist li {
  display: inline;
  list-style-type: none;
  padding-right: 20px;
}
input[type="checkbox"] {
  transform: scale(1.3);
  margin-right: 10px;
}
</style>
